import script from "./BirthdaysCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdaysCard.vue?vue&type=script&setup=true&lang=js"

import "./BirthdaysCard.vue?vue&type=style&index=0&id=ed31fb66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed31fb66"]])

export default __exports__